module.exports = __webpack_public_path__ + "img/newspapers_button_right_up.20b9aedc.png";